import PropTypes from 'prop-types'
import PDFViewer from './PDFViewer'
// import isPDF from './utils/isPDF'
// import ImageViewer from './ImageViewer'

/**
  * Custom `ViewportContent` component declaration.
  * @param {Object} file
  * @param {String} fiel.url
  * @param {String} fiel.data
  * @param {String} fiel.name
  * @param {String} fiel.mimeType
  * @param {Number} totalPages
  * @param {Function} onPageChange
  * @param {Function} onLoadSuccess
  * @return ViewportContent
*/
const ViewportContent = ({
  file,
  totalPages,
  containerRef,
  onPageChange,
  currentPage,
  // originalSizes,
  onLoadSuccess,
}: any) => (
  <div ref={containerRef} className={'preview-content'}>
    <div className="preview-file">
      {/* {isPDF(file) ? (
        <PDFViewer
          file={file}
          totalPages={totalPages}
          onPageChange={onPageChange}
          onLoadSuccess={onLoadSuccess}
        />
      ) : (
        <ImageViewer
          file={file}
          onLoadSuccess={onLoadSuccess}
          originalSizes={originalSizes}
        />
      )} */}
        <PDFViewer
          file={file}
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={onPageChange}
          onLoadSuccess={onLoadSuccess}
        />
    </div>
  </div>
)

ViewportContent.propTypes = {
  file: PropTypes.shape({
    url: PropTypes.string,
    data: PropTypes.string,
    name: PropTypes.string,
    mimeType: PropTypes.string,
  }),
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  onLoadSuccess: PropTypes.func.isRequired,
}

export default ViewportContent